import { FieldValues } from 'react-hook-form';
import { IMaskInputProps, IMaskMixin } from 'react-imask';

import ControlledTextField, {
  ControlledTextFieldProps,
} from './ControlledTextField';

import type { JSX } from 'react';

export type MaskedTextFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = IMaskInputProps<HTMLInputElement> & ControlledTextFieldProps<TFieldValues>;

// The data attribute declaration in App.tsx causes TypeScript to create union types that are too complex
// when combined with IMaskMixin and an error is thrown. Any is used so TS stops trying to expand the union,
// then a type assertion is used to work around it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MaskedTextField = IMaskMixin<HTMLInputElement, any>(
  ({ inputRef, defaultValue, ...otherProps }) => (
    <ControlledTextField
      {...(otherProps as unknown as ControlledTextFieldProps<FieldValues>)}
      inputRef={inputRef}
    />
  )
) as <TFieldValues extends FieldValues = FieldValues>(
  props: MaskedTextFieldProps<TFieldValues>
) => JSX.Element;

export default MaskedTextField;
